import { HttpErrorResponse } from '@angular/common/http';

import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { CmsPageActions } from './cms-pages.actions';
import { RootActions } from '../root.actions';

import { CmsComponentConfig, TCustomCmsPageType } from '@interfaces/config';
import { Breadcrumb } from '@models/interfaces';

export interface StoredComponentConfig {
  id: string;
  cacheKey: string;
  breadcrumbs: Breadcrumb[];
  newsletterCta: boolean;
  cmsPageType: TCustomCmsPageType;
  componentConfigs: CmsComponentConfig<any>[];
}

export interface CmsPagesState extends EntityState<StoredComponentConfig> {
  updated: number | null;
  loading: boolean;
  error: HttpErrorResponse | string | null;
}

export const adapter: EntityAdapter<StoredComponentConfig> = createEntityAdapter();

export const initialState: CmsPagesState = adapter.getInitialState({
  updated: null,
  loading: false,
  error: null,
});

export type State = Readonly<typeof initialState>;

const cmsPagesReducer = createReducer(
  initialState,
  on(RootActions.rehydrate, (state, action) => ({ ...state, ...action.state.cmsPages })),
  on(CmsPageActions.fetch, state => ({ ...state, loading: true, error: null })),
  on(CmsPageActions.fetchSuccess, (state, { payload }) => {
   

    const id = btoa(payload.url);

    const { cacheKey, breadcrumbs, componentConfigs, newsletterCta, cmsPageType } = payload;

   
    return adapter.upsertOne(
      { id, cacheKey, cmsPageType, componentConfigs, breadcrumbs, newsletterCta },
      { ...state, loading: false, updated: Date.now() }
    );
  }),
  on(CmsPageActions.fetchError, (state, { error }) => ({ ...state, loading: false, error })),
  on(RootActions.NULL_ACTION, state => ({ ...state, loading: false }))
);

export const reducer = (state: State | undefined, action: Action) => {
  return cmsPagesReducer(state, action);
};
